import React , {useEffect, useState} from 'react'
import verified from  "../../images/vff.png"
import logo from  "../../images/logo.png"
import { db } from "../../firebase";
import { collection, onSnapshot, query} from 'firebase/firestore';
import Loading from './Loading';


function HomeScreen() {
    const [ dataRecords, setDataRecords] = useState([])
    const [ order, setOrder] = useState(false)
    const [isLoading, setIsLoading] = useState(false)

    useEffect(() => {
    setIsLoading(true)
    const q  = query(collection(db,"AllPosts"));    
    const unsub = onSnapshot(q, (querySnapshot) => {
        let todoArray = [];
        querySnapshot.forEach((doc) => {
          todoArray.push({...doc.data(),
             id: doc.id 
            });
        })
        setDataRecords(todoArray)
        setIsLoading(false)
      })
      return () => unsub()
  },[])

  return (
    <>
    <div className='container bg-dark container-lg container-md container-sm min-h-screen pb-6'>
     <div className="container px-2 items-center justify-center text-center flex flex-col">
        <div className="rounded-full overflow-hidden" style={{height:170, width:180}}><img src={logo} alt="logo" /></div>

        {/* channel name and two line description ->> header */}
        <div className="font-bold sans-serif mt-2 flex gap-1 justify-center items-center">
            <div className="dark:text-white ">Shadab Lucky</div> 
            <img style={{width:20, height:20}} src={verified} alt="logo" />
        </div>
        <div className='pb-1'>
            <div className="text-xs w-44">Tech - Tips - Tricks</div>
        </div>
        
        {/* contact and subscribe section ->> Header */}
       <div className="flex flex-row gap-2 py-1 pb-5">
         <div className="btn btn-danger py-1"><a href="https://www.instagram.com/shadab___lucky/" target="/blank" >Contact US</a></div>
         <div className="btn btn-danger py-1 animate-pulse" ><a href="https://www.youtube.com/channel/UCDN85080kbXaFuXCJZaqYCw" target="/blank" >Subscribe YT</a></div>
       </div>
     </div>
<div className="flex flex-row gap-3 py-2">
{
  order?
  <button  className='text-white border-b-2 border-b-white' onClick={()=>setOrder(false)}>Show recent posts</button>
  :
  <button  className='text-white border-b-2 border-b-teal-600'>Show recent posts</button>
}
{
  order?
  <button  className='text-white border-b-2 border-b-teal-600' >Show older posts</button>
  :
  <button  className='text-white border-b-2 border-b-white' onClick={()=>setOrder(true)}>Show older posts</button>
}
</div>

    {/* this is post section */}
     <div className="space-around">
         {/* All UPLOADED POST SECTION -->> DATA MAPPING.... */}
      <div className="row gap-1">
        <div className="col items-center justify-between p-1">
        {
         isLoading? 
         <Loading/> : null
        }
        {
          dataRecords && dataRecords 
          .sort((a,b) => order? (a.serialNumber - b.serialNumber):(b.serialNumber - a.serialNumber)) //we are reversing and sorting
          .map((data,id)=>(
            <div  key={id} className="col-lg-4 col-md-6 col-sm-12 float-start rounded-xl mb-3 shadow shadow-teal-900 overflow-hidden px-1">
          <div className="card w-100">
            <div className="card-header flex flex-row items-center ">
                  <div className="rounded-full overflow-hidden mr-1"><img className='rounded-full bg-black'src={logo} style={{height:45, width:45}} alt="logo"  /></div>
                  <div className="text-sm w-5/6 font-bold ">{data.postheader}</div>
            </div>
            <div className="card-body p-0 px-3 pb-2 py-1">
                <div className="border justify-center items-center flex">
                    <img src={data.postImage} style={{height:180, width:330}} alt="thumbnail"  />
                </div>
                {/* post description here */}
                <div className=" flex">
                    <div className="text-xs py-2 h-20 px-1 ">{data.description}</div>
                </div>
                <div className="flex flex-row gap-2 justify-center items-center px-10">
                    <div className="btn bg-teal-700 hover:bg-teal-900 btn-sm text-white"><a href={data.btnUrlOne} target="/blank" >Download apk</a></div>
                    <div className="btn btn-danger btn-sm"><a href={data.btnUrlTwo}  target="/blank" >watch tutorial</a></div>
                </div>
               
                
            </div>
            <div className="card-footer justify-center items-center flex">
                <div className="justify-center items-center">
                <div className=""><span className='animate-pulse'>❤️</span>Thank you for Downloading<span className='animate-pulse'>❤️</span></div>
                    {/* <a className='btn bg-slate-600 text-white font-semibold' href='https://google.com'>Vist our official channel</a> */}
                </div>
            </div>
          </div>
          </div>
            ))
        }
        
        </div>
       </div>
     
     </div>

     
    </div>

           {/* website footer credit */}
          <div className="py-2 footer bottom-0">
          <div className="rounded-t px-2 py-3 bg-dark">
           <div className="flex flex-row items-center justify-center float-left">
             <img className='rounded-full' src={logo} style={{width:100, height:90}} alt="logo" />
             <div className="text-sm font-serif font-semibold px-1 text-white"><a href='https://www.youtube.com/channel/UCDN85080kbXaFuXCJZaqYCw' target="/blank" className='nav-link'>Shadab Lucky</a></div>
           </div>
          <div className=" flex flex-row font- justify-around ">
          <ul className='pt-1 text-sm text-white text-left flex-col flex'>
             <li className='nav-item underline cursor-pointer' ><a href='#' className='nav-item text-start'>Home</a></li>
             <li className='nav-item underline cursor-pointer' ><a href='https://www.youtube.com/channel/UCDN85080kbXaFuXCJZaqYCw' target="/blank" className='nav-link'>Subscribe</a></li>
           </ul>
          <ul className='pt-1 text-sm text-white text-left flex-col flex'>
             <li className='nav-item underline cursor-pointer' ><a href='#' className='nav-item'>About Us</a></li>
             <li className='nav-item underline cursor-pointer' ><a href="https://www.instagram.com/shadab___lucky/" target="/blank" className='nav-link'>Instagram</a></li>
             <li className='nav-item underline cursor-pointer' ><a href='mailto:love.me.love7595@gmail.com' className='nav-item'>Email</a></li>
           </ul>
          </div>
          <div className="card card-footer text-xs justify-center items-center w-full text-white flex mt-10">
            <small > © www.telegram.me/LazyDeveloper</small>
            <small className='font-mono '> All Rights Reserved</small>
          </div>
        </div>
          </div>
</>
  )
}

export default HomeScreen